module.exports = __webpack_public_path__ + "img/fd_money_img.1e505ea3.png";